
import { PageTemplateContent, Header2 } from 'app/common/templates-next/page-template'
import Sticky from 'app/common/templates-next/sticky'
import SaleTypesData from 'app/dataProviders/SaleTypesData'
import { SelectionStateProvider } from 'app/common/ui-components/table'

import { ProductionTypesToolbar } from './components'
import { ProductionTypesTable } from './ProductionTypesTable'


type Props = {
  disabled?: boolean
}

export const SectionProductionTypes = ({ disabled }: Props) => {
  return (
    <SaleTypesData>
      <SelectionStateProvider>
        <Sticky>
          {(ref, _, shadow) => (
            <PageTemplateContent
              horizontalLayout
              shadowBottom={shadow}
              reference={ref}
            >
              <Header2 skipMargin>{'Тип продукции'}</Header2>
            </PageTemplateContent>
          )}
        </Sticky>
        <PageTemplateContent>
          <ProductionTypesToolbar disabled={disabled} />
        </PageTemplateContent>
        <PageTemplateContent skipPadding>
          <ProductionTypesTable disabled={disabled} />
        </PageTemplateContent>
      </SelectionStateProvider>
    </SaleTypesData>
  )
}
